import React, { type PropsWithChildren } from 'react';
import { Box } from '../../../Box';
import { dataTableClassnames } from '../const/classNames';

export const Header: React.FC<PropsWithChildren> = ({ children }) => {
  return <Box className={dataTableClassnames.header.root}>{children}</Box>;
};
